import { render, staticRenderFns } from "./BannerTeam.vue?vue&type=template&id=01d9a200&scoped=true"
import script from "./BannerTeam.vue?vue&type=script&lang=js"
export * from "./BannerTeam.vue?vue&type=script&lang=js"
import style0 from "./BannerTeam.vue?vue&type=style&index=0&id=01d9a200&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d9a200",
  null
  
)

export default component.exports